/* eslint-disable jira/filename-case */

import { withChoreographedRender } from '@jira/platform__choreographer-services/src/withChoreographedRender.tsx';
import type { ChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import Spotlight from '@atlaskit/onboarding/spotlight';
import type { SpotlightProps as SpotlightPropsTypes } from '@atlaskit/onboarding/types';

export const ChoreographerSpotlight: {
	(props: SpotlightPropsTypes & ChoreographedComponentProps): React.JSX.Element;
	displayName: string;
} = withChoreographedRender<SpotlightPropsTypes>(Spotlight);
